<template>
  <v-card>
    <v-container fluid>
      <v-toolbar dark color="primary">
        <v-btn icon>
          <v-icon @click="$router.go(-1)">mdi-backspace</v-icon>
        </v-btn>
        <v-toolbar-title>Discipline Referrals</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <teacherview v-if="isStaff()" />
      <studentview v-if="isStudent()" />
    </v-container>
  </v-card>
</template>
<script>
import teacherview from "../components/disciplineTeacherView.vue";
import studentview from "../components/disciplineStudentView.vue";
export default {
  components: {
    teacherview,
    studentview,
  },

  data: () => ({}),
  computed: {},
  methods: {},
  mounted() {},
};
</script>